// extracted by mini-css-extract-plugin
module.exports = {"tbl_cnt":"style_tbl_cnt__2Gnn7"};